import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_search",
  "use": "icon-icon_search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_search\">\r\n<path d=\"M7.96875 2.6875C9.36942 2.6875 10.7127 3.24392 11.7032 4.23434C12.6936 5.22477 13.25 6.56808 13.25 7.96875C13.25 9.27688 12.7706 10.4794 11.9825 11.4056L12.2019 11.625H12.8438L16.9062 15.6875L15.6875 16.9062L11.625 12.8438V12.2019L11.4056 11.9825C10.4794 12.7706 9.27688 13.25 7.96875 13.25C6.56808 13.25 5.22477 12.6936 4.23434 11.7032C3.24392 10.7127 2.6875 9.36942 2.6875 7.96875C2.6875 6.56808 3.24392 5.22477 4.23434 4.23434C5.22477 3.24392 6.56808 2.6875 7.96875 2.6875ZM7.96875 4.3125C5.9375 4.3125 4.3125 5.9375 4.3125 7.96875C4.3125 10 5.9375 11.625 7.96875 11.625C10 11.625 11.625 10 11.625 7.96875C11.625 5.9375 10 4.3125 7.96875 4.3125Z\" fill=\"#0E419D\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_search.svg
// module id = A//U
// module chunks = 16